export default __webpack_public_path__ + "static/konkurs-0c1f6606bad0805e521bb73b0b76000c.png";